import React, { useState, useEffect,useRef } from "react";
import { useParams,useNavigate,Link } from 'react-router-dom';
import axios from 'axios';

import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

import Header from "../../components/includes/Header";
import { isNull,escapeHtml,unescapeHtml,ChangeDateStringOnlyDate,ChangeSearchingDateFormat,SetEmptyInputFile } from "../../../components/common/Common";
import cancelIcon from "../../../img/icon/icon-cancel.svg";

//게시판 정보 편집
function NoticeDetail() {
  const admin_idx = Number(localStorage.getItem('adminIdx'));
  const admin_name = localStorage.getItem('adminName');
  let { board_idx } = useParams();
  const navigate = useNavigate();
  const fileRef = useRef(null);

  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);


  //게시판 변수 저장 객체
  const newData = {      
    board_idx: 0,
    board_bh_idx:0,
    mem_idx: admin_idx,
    mem_name: admin_name,
    board_top: 0,
    board_title: "",
    board_comment: "",
    board_rdate: ChangeSearchingDateFormat(new Date(),'.'),
    board_attach:0,
    board_file:'',
    board_real_file:'',
    board_hits: 0,
    board_status:1
  };

  //게시판정보
  const [varNoticeInfo,setNoticeInfo] = useState({});
  //편집유무
  const [varSendPush,setSendPush] = useState(false);

  //게시판정보 읽어오기
  const getNoticeInformation = async () => {
    if(Number(board_idx) === 0) {
      setNoticeInfo(newData);
    //게시판 정보를 서버로부터 읽어오기
    } else {
      var sendData = {mode:1,board_idx: board_idx};
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/_get_board_information`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          if(datas.results?.length > 0) {
            setNoticeInfo(datas.results[0]);
          }
        }
      });
    }
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setAdminMenus({type:'ENVIRONMENT',item:'Notice'});
    console.log(varAdminMenus);
    getNoticeInformation();
    if(Number(board_idx) === 0) setSendPush(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [board_idx]);

  //회원정보편집
  const onNoticeInfoHandler = (e) => {
    const {name,value} = e.currentTarget;
    if(name === "board_comment") {
      setNoticeInfo({...varNoticeInfo, [name]:escapeHtml(value)});
      if(!varSendPush) setSendPush(true);
    } else if(name === "board_top") {
      setNoticeInfo({...varNoticeInfo, [name]:Number(value)});
    } else {
      setNoticeInfo({...varNoticeInfo, [name]:value});
    }
  }

  //공지사항삭제---------
  const onDeleteNoticeHandler = async(e) => {
    if (!window.confirm("선택된 공지사항 정보를 삭제합니까?")) return false;
    const boardIndexString = [varNoticeInfo.board_idx];
    const sendData = {mode:1,delitems: boardIndexString};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_delete_board_list`, sendData).then((res) => {
      console.log(res.data);
      if (res.data.retvalue === 1) {
        navigate(`/Admin/NoticeList`);
      } else {
        alert(res.data.message);
      }
    });  
  }

  //사진 선택후 화면에서 표시
  const onChangeAttachFileHandler = (e) => {
    const uploadFile = fileRef.current.files[0];
    console.log(uploadFile);
    //변수값 재조정
    setNoticeInfo({...varNoticeInfo, board_attach:1,board_real_file:uploadFile.name});
  }
  
  //사진삭제
  const onDeleteAttachFileHandler = async(e) => {
    if(isNull(varNoticeInfo.board_file)) {
      const fileBox = fileRef.current;
      SetEmptyInputFile(fileBox);
      setNoticeInfo({...varNoticeInfo, board_attach:0,board_real_file:null});
    } else {
      if(!window.confirm("첨부된 파일을 삭제하시겠습니까?")) return false;
      const sendData = {board_idx:board_idx};
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/branch_delete_notices_attachfile`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          setNoticeInfo({...varNoticeInfo, board_attach:0,board_file:null,board_real_file:null});
        } else {
          alert(datas.message);
        }
      });
    }
  }

  //공지사항정보 서버에 등록---------
  //공지사항정보등록전에 첨부파일 저장
  const onUpdateNoticeHandler = async (e) => {
    let prompt = "현재 선택된 공지사항의 정보를 저장합니까?";
    if(varNoticeInfo.board_idx === 0)  prompt = "입력하신 공지사항을 등록합니까?";
    if(!window.confirm(prompt)) return false;

    if(varNoticeInfo.board_attach===1 && !isNull(fileRef.current.files[0])) {
      let formData = new FormData();
      formData.append('notices',fileRef.current.files[0]);
      await axios.post(`${process.env.REACT_APP_HOST}/notices`,formData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          const fileName = datas.fileName;
          UpdateNoticeInformation(fileName,fileRef.current.files[0].name);
        } else {
          alert(datas.message);
        }
      });
    } else {
      UpdateNoticeInformation("");
    }
  }
  //공지사항정보등록---------
  const UpdateNoticeInformation = async(fileName,realName) => {
    const sendData = {mode:1,boardInfo:varNoticeInfo,fileName:fileName,realName:realName};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_board_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(varSendPush) SendPushMessage(datas.board_idx);
        else navigate(`/Admin/NoticeList`);
      } else {
        alert(datas.message);
      }
    });
  }

  //푸시보내기
  const SendPushMessage = async (board_idx) => {
    if(!window.confirm("푸시메시지를 발송하시겠습니까?")){
      navigate(`/Admin/NoticeList`);
      return false;
    } 
    const pushTitle = "[마마몽떼] 새로운 공지사항이 등록되었습니다.";
    const pushMessage = varNoticeInfo.board_title;

    //학부모에게
    const pushUrl = `${process.env.REACT_APP_WEB_URL}/Parents/NoticeView/${board_idx}`;
    const sendData = {bh_idx:0,pushTitle:pushTitle,pushMessage:pushMessage,pushUrl:pushUrl};
    console.log(sendData);
    const res = await axios.post(`${process.env.REACT_APP_HOST}/branch_push_multi_message`,sendData);
    const datas = res.data;
    console.log(datas);
    
    if(datas.retvalue === 0) {
      alert(datas.message);
      return false;
    }

    //대리점에게
    const pushUrl2 = `${process.env.REACT_APP_WEB_URL}/Branch/NoticeDetail/${board_idx}`;
    const sendData2 = {pushTitle:pushTitle,pushMessage:pushMessage,pushUrl:pushUrl2};
    console.log(sendData);
    const res2 = await axios.post(`${process.env.REACT_APP_HOST}/admin_push_multi_message`,sendData2);
    const datas2 = res2.data;
    alert(datas.message);
    console.log(datas2);
    navigate('/Admin/NoticeList');
  }

  //첨부파일 다운로드
  /* const onAttachDownloadHandler = (e) => {
    const downfile = `${process.env.REACT_APP_HOST}/notices/${varNoticeInfo.board_file}`;
    DownloadFile(downfile,varNoticeInfo.board_real_file,0);
  } */

  return (    
    <div id="admin_contents" className="adm_contents">
      <Header varTitle={'공지사항상세'} varDirection={'설정'}/>
      <div className="admin-content">
        <div className="main-box">
          <table className="write">
            <colgroup>
              <col width="20%"></col>
              <col width="80%"></col>
            </colgroup>
            <thead></thead>
            <tbody>
              <tr>
                <th>등록일자</th>
                <td>{ChangeDateStringOnlyDate(varNoticeInfo.board_rdate||"")}</td>
              </tr>
              <tr>
                <th>등록자</th>
                <td>{varNoticeInfo.mem_name||""}</td>
              </tr>
              <tr>
                <th>상단고정유무</th>
                <td>
                  <select value={varNoticeInfo.board_top} name="board_top" style={{width:"200px"}} onChange={(e)=>onNoticeInfoHandler(e)}>
                    <option value={0}>일반</option>
                    <option value={1}>상단고정</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>제목</th>
                <td><input type="text" name="board_title" value={unescapeHtml(varNoticeInfo.board_title||"")} onChange={(e)=>onNoticeInfoHandler(e)}/></td>
              </tr>
              <tr>
                <th>내용</th>
                <td><textarea name="board_comment" style={{maxWidth:"100%"}} value={unescapeHtml(varNoticeInfo.board_comment||"")} onChange={(e)=>onNoticeInfoHandler(e)}/></td>
              </tr>
              <tr>
                <th>첨부파일</th>
                <td>
                  <div style={{width:"100%",display:"flex",flexDirection:"row"}}>
                    <input type="file" ref={fileRef} name="file" style={{width:"90px",border:"none"}} onChange={e=>onChangeAttachFileHandler(e)} />
                    {varNoticeInfo.board_attach===0?null:
                      <div className={`file-box`} style={{marginLeft:"30px",paddingTop:"6px",display:"flex",flexDirection:"row"}}>
                        <p style={{paddingTop:"10px"}}>{varNoticeInfo.board_real_file}</p>
                        <button className="btn-cancel" style={{border:"none",paddingLeft:"0px"}} onClick={e=>onDeleteAttachFileHandler(e)}><img src={cancelIcon} alt="" /></button>
                        {/* <button className="btn black line" onClick={e=>onAttachDownloadHandler(e)}>다운로드</button> */}
                      </div>
                    }
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="btn-center">
            <Link to={`/Admin/NoticeList`} style={{width:"100px"}} className="btn line">목록</Link>
            <button className="btn-danger" style={{width:"100px"}} onClick={(e)=>onUpdateNoticeHandler(e)}>저장</button>
            <button className="btn black" style={{width:"100px"}} onClick={(e)=>onDeleteNoticeHandler(e)}>삭제</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoticeDetail;